import type { LootAnnouncementOutcome } from '@vlastiq/contracts';

/**
 * How an announcement outcome reads, and how loudly.
 *
 * ⚠️ ONE DESCRIPTION FOR BOTH SCREENS. Главная and Админка → Ротация лута each
 * render the queue and each report what came of a write; the one thing that must
 * not differ between them is the TONE, because two screens disagreeing about
 * whether the bot staying quiet is a failure teaches whoever reads the noisier
 * one to ignore it. Both call this, and neither decides for itself.
 *
 * ⚠️ ONLY `send_failed` IS `danger`, and that is the point of the type.
 * `empty_queue`, `unchanged`, `not_announced` and `reorder_not_announced` are
 * the feature declining to make noise in a real group chat, and `bot_disabled`
 * is the state this repository SHIPS in — a red alert on any of the five trains
 * an admin to treat the guard as a flaky endpoint. `send_failed` is the one
 * where the queue moved and the group does not know.
 *
 * ⚠️ PURE, AND IN `lib/` FOR THAT REASON. It sat in `LootQueue.tsx` next to the
 * component, which imports HeroUI and therefore React — and the test runner here
 * is Bun with no DOM, so nothing in that file could be tested. The mapping from
 * six outcomes to two tones is exactly the kind of thing that should be.
 */
export interface LootAnnouncementNotice {
  tone: 'quiet' | 'danger';
  text: string;
}

export function describeLootAnnouncement(
  outcome: LootAnnouncementOutcome,
): LootAnnouncementNotice {
  if (outcome.posted) return { tone: 'quiet', text: 'Бот объявил очередь в группе.' };

  switch (outcome.reason) {
    case 'empty_queue':
      return { tone: 'quiet', text: 'Бот промолчал — в ротации пока никого.' };
    case 'unchanged':
      /*
       * ⚠️ NO LONGER «Бот промолчал — …», and the dropped half is the point.
       * Since DECISION-43 the three reorder writes never ask the bot anything,
       * so leading with its silence answered a question nobody had asked and
       * buried the one fact that matters: the queue is exactly as it was. This
       * is now the only outcome that is a statement about the QUEUE rather than
       * about the bot.
       */
      return { tone: 'quiet', text: 'В очереди ничего не изменилось.' };
    case 'reorder_not_announced':
      /*
       * ⚠️ THIS IS A RECEIPT, AND IT IS THE ONLY ONE A DRAG GETS. The row moved
       * under the pointer the instant it was dropped, so the screen looks
       * identical whether the write landed or was never sent — «порядок
       * сохранён» is the whole confirmation. The second sentence is there
       * because the previous behaviour DID write to the group on a reorder, and
       * an admin who remembers that needs telling it stopped.
       */
      return {
        tone: 'quiet',
        text: 'Порядок сохранён. В группу ничего не ушло — это перестановка.',
      };
    case 'not_announced':
      /*
       * ⚠️ NOT the same sentence as `unchanged`, and the difference is the whole
       * reason the reason exists. «Не явился» DOES move somebody to the back;
       * telling an admin «ничего не изменилось» after it would read as a dead
       * button and get pressed again, moving the same person twice.
       */
      return {
        tone: 'quiet',
        text: 'Очередь обновлена. О пропусках бот в группу не пишет — следующего он назовёт сам.',
      };
    case 'bot_disabled':
      return {
        tone: 'quiet',
        text: 'Бот выключен, поэтому в группу ничего не ушло. Очередь изменилась.',
      };
    case 'send_failed':
      return {
        tone: 'danger',
        text: 'Не удалось отправить сообщение в Telegram. Очередь изменилась, а группа об этом не знает.',
      };
  }
}
